// hooks/useScrollToHash.js — a link to /#jobs lands on the jobs section.
//
// A single-page app does not do this by itself: the router swaps the page
// without the browser ever looking for the #fragment, so a footer link to a
// section of the landing page opened the top of it. Runs after the page has
// rendered, and again whenever the fragment changes.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash || hash.length < 2) return;
    let el = null;
    try { el = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { el = null; }
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'start' });
  }, [hash]);
}
